<template>
  <div class="content-wrap">
    <div
      class="
        action-panel
      ">
      <div panel="main">
        <p>
          <b>รายการลูกบ้าน</b>
        </p>
        <p class="subtitle">
          พบ <b>{{ paging.total }}</b> รายการ
        </p>
      </div>
      <hr/>
      <div panel="action">
        <el-button
          type="primary"
          icon="
            el-icon-circle-plus
          "
          plain
          @click="
            () => creator.open = true
          ">
          เพิ่มลูกบ้าน
        </el-button>
      </div>
    </div>

    <section
      v-if="
        paging.total == 0
      "
      class="empty">
      <img
        src="@/assets/images/admin/empty.png"
      />
      <p>
        <b class="unknown">
          ไม่พบข้อมูล
        </b>
      </p>
    </section>

    <div
      v-if="
        paging.total > 0
      "
      class="
        content-list
      ">
      <NonScHomeRoleItem
        v-for="
          (item, i) in items
        "
        :key="i"
        :role="item"
        @edit="
          () => edit(item)
        "
        @remove-role="
          () => removeRole(item)
        "
      />
    </div>

    <div
      v-if="
        paging.total > 0
      "
      class="pager">
      <el-pagination
        :background="true"
        :layout="
          'prev, pager, next'
        "
        @current-change="
          (page) => $emit('page-change', page)
        "
        :pager-count="
          paging.count
        "
        :current-page="
          paging.page
        "
        :page-size="
          paging.limit
        "
        :total="
          paging.total
        "
      />

      <NonScUserEditor
        :mode="
          'update'
        "
        :open="
          editor.open
        "
        :form="
          editor.form
        "
        @update-user="
          value => updateUser(value)
        "
        @remove-user="
          value => removeUser(value)
        "
        @closed="
          () => editor.open = false
        "
      />
    </div>

    <NonScUserEditor
      :mode="
        'create'
      "
      :open="
        creator.open
      "
      @create-user="
        value => createUser(value)
      "
      @create-role="
        value => createRole(value)
      "
      @closed="
        () => creator.open = false
      "
    />

    <NonScAlert
      type="error"
      :open="
        confirm.open
      "
      :head="
        confirm.head
      "
      :message="
        confirm.message
      "
      :disabled="
        !confirm.action
      "
      :cancel="true"
      @confirm="
        () => call(confirm.action)
      "
      @closed="
        () => confirm.open = false
      ">
    </NonScAlert>
  </div>
</template>
<script lang="js">

// Common
import {
  NonScCommon as Common
} from '../../common/nonsc.common'

import {
  NonScUserCommon as UserCommon, UserItem
} from '../../common/nonsc-user.common'

// Components
import NonScAlert from '../../components/NonScAlert.vue'
import NonScHomeRoleItem from './NonScHomeRoleItem.vue'
import NonScUserEditor from '../user/NonScUserEditor.vue'

export default {
  components: {
    NonScAlert,
    NonScHomeRoleItem,
    NonScUserEditor,
  },
  props: {
    page: {
      type: Number,
      default: 1
    },
    roles: {
      type: Array,
      default: []
    },
    total: {
      type: Number,
      default: 0
    }
  },
  data() {
    
    /** @type {UserItem[]} */
    const items = []
 
    // Paging State
    const paging = {
      page  : 1,
      count : 5,
      total : 0
    }

    // Confirm State
    const confirm = {
      open    : false,
      head    : 'ลบข้อมูล',
      message : null,
      action  : null
    }

    // Editor State
    const editor = {
      open: false,
      form: (
        Object.assign({}, UserCommon.input)
      )
    }
    
    // Editor State
    const creator = {
      open: false,
      form: (
        Object.assign({}, UserCommon.input)
      )
    }

    return {
      items,
      creator,
      editor,
      paging,
      confirm
    }
  },
  watch: {
    roles() {
      this.setItems()
    },
    page(value) {
      this.paging.page = value || 1
    },
    total(value) {
      this.paging.total = value || 0
    },
  },
  mounted() {

    // Set Items
    this.setItems()

    // Pagination
    const page = this.page
    const total = this.total

    // Set Paging
    Object.assign(
      this.paging, { page, total }
    )
  },
  methods: {
    setItems() {
      this.items = this.roles
    },
    edit(item) {

      // Validate User
      if (!item) return

      // Item Props
      const { user, role } = item

      // Set Editor Form
      const form = { ...user, role }

      // Set Editor
      Object.assign(
        this.editor, { open: true, form }
      )
    },
    call(action) {
      if (typeof action =='function') action()
    },
    createUser(input){
      
      // Validate Input
      if (!input) return
      
      // Emit Event
      this.$emit(
        'create-user', input
      )
    },
    updateUser(input) {

      // Validate Input
      if (!input) return
      
      // Emit Event
      this.$emit(
        'update-user', input
      )
    },
    removeUser(value) {

      // Validate User
      if (!value || !value.id) return

      /** @type {UserItem} */
      const { id, firstName } = value

      // Confirm Message
      const message = (
        `ต้องการลบข้อมูลลูกบ้าน ${firstName}?`
      )

      // Set Confirm Action
      const action = () => this.$emit(
        'remove-user', id
      )

      // Set Confirm
      Object.assign(
        this.confirm, {
          open: true, message, action
        }
      )
    },
    createRole(value) {
      
      // Validate User
      if (!value) return

      // Emit Event
      this.$emit(
        'create-role', value
      )
    },
    removeRole(value) {

      // Validate User
      if (!value) return

      /** @type {RoleItem} */
      const { id, role } = value

      // Role Props
      const { name } = (
        Common.setRole(role)
      )

      // Confirm Message
      const message = (
        `ต้องการลบสถานะ ${name}?`
      )

      // Set Confirm Action
      const action = () => this.$emit(
        'remove-role', id
      )

      // Set Confirm
      Object.assign(
        this.confirm, {
          open: true, message, action
        }
      )
    },
  }
}

</script>

<style lang="css" scoped>

.content-wrap {
  display : grid;
  gap     : var(--size-sm);
}

.content-head {
  display         : flex;
  gap             : var(--size-sm);
  justify-content : space-between;
}

.content-list {
  display : grid;
  gap     : var(--size-sm);
}

.action-panel hr {
  display: none;
}

@media screen and (max-width: 1024px) {
  
  .action-panel hr {
    display: block;
  }
}

</style>


// WEBPACK FOOTER //
// src/features/nonsc/pages/home/NonScHomeRole.vue